import { useState, useRef } from 'react'
import { parseCSV } from '../utils/parseCSV'
import { useDonation } from '../context/DonationContext'

export default function FileUpload() {
  const { setDonations, filterDonations, clearSavedData } = useDonation()
  const [fileName, setFileName] = useState<string | null>(null)
  const [progress, setProgress] = useState(0)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileSelect = (file?: File) => {
    if (!file) {
      console.log('No file selected')
      return
    }
    
    setFileName(file.name)
    processCSV(file)
  }

  const processCSV = (file: File) => {
    const reader = new FileReader()

    reader.onload = function(e) {
      const csv = e.target?.result as string
      const parsedDonations = parseCSV(csv)
      console.log('Parsed donations:', parsedDonations)
      setDonations(parsedDonations)
      filterDonations()
      localStorage.setItem('donations', JSON.stringify(parsedDonations))
    }

    reader.onprogress = function(e) {
      if (e.lengthComputable) {
        const percentLoaded = Math.round((e.loaded / e.total) * 100)
        setProgress(percentLoaded)
      }
    }

    reader.readAsText(file)
  }

  const handleClearSavedData = () => {
    clearSavedData()
    setFileName(null)
    setProgress(0)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  return (
    <div id="uploadForm" className="flex-item">
      <div className="flex justify-between items-center">
        <div 
          id="dropZone" 
          className="border-2 border-dashed border-gray-300 rounded-lg p-6 w-full text-center cursor-pointer hover:border-primary transition-colors"
          onClick={() => fileInputRef.current?.click()}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault()
            if (e.dataTransfer.files.length > 0) {
              handleFileSelect(e.dataTransfer.files[0])
            }
          }}
        >
          <div id="dropZoneContent">
            {fileName ? (
              <p className="text-gray-800 font-semibold">{fileName}</p>
            ) : (
              <p className="text-gray-500">Drag and drop your CSV file here or click to upload</p>
            )}
          </div>
          <input 
            type="file" 
            id="csvFile" 
            ref={fileInputRef}
            accept=".csv" 
            className="hidden"
            onChange={(e) => e.target.files && handleFileSelect(e.target.files[0])}
          />
        </div>
        <div className="flex justify-end ml-4">
          <button onClick={() => fileInputRef.current?.click()} className="bg-primary hover:bg-primary/80 text-white font-bold py-2 px-4 rounded">Process CSV</button>
          <button onClick={handleClearSavedData} className="bg-secondary hover:bg-secondary/80 text-white font-bold py-2 px-4 rounded ml-2">Clear Saved Data</button>
        </div>
      </div>
      {progress > 0 && progress < 100 && (
        <div id="progressBarContainer" className="mt-2">
          <progress id="uploadProgress" value={progress} max="100" className="w-full"></progress>
          <span id="progressPercentage" className="text-sm text-gray-600">{progress}%</span>
        </div>
      )}
    </div>
  )
}

